import type { BigNumber } from 'mathjs';
import InitialPortfolioStep from './InitialPortfolioStep.tsx';
import { fields, label } from '../../initialPortfolio/InitialPortfolioStepConfig.tsx';
import type { StepConfig } from '../../../../../technical/wizard/StepConfig.ts';
import type { InitialPortfolioStepInput } from '../../initialPortfolio/InitialPortfolio.validation.ts';
import type { NotVerifiedAssetWithId } from 'components/market/asset/AssetService.tsx';

export const config = ({
  assets,
  assetIdToClusterToGroup,
  aggregatedPortfolioValuesByAsset,
  goToNextStep,
}: {
  assets: NotVerifiedAssetWithId[];
  assetIdToClusterToGroup: Record<string, Record<string, string>>;
  aggregatedPortfolioValuesByAsset: Map<string, BigNumber>;
  goToNextStep: () => void;
}): StepConfig<InitialPortfolioStepInput> => ({
  label,
  element: (
    <InitialPortfolioStep
      assets={assets}
      goToNextStep={goToNextStep}
      assetIdToClusterToGroup={assetIdToClusterToGroup}
      aggregatedPortfolioValuesByAsset={aggregatedPortfolioValuesByAsset}
    />
  ),
  fields,
});
